import { useCallback, useMemo, useState } from 'react';
import { usePopper } from 'react-popper';
export function useContextMenuPlacement(placement) {
    const [positionState, setPositionState] = useState(null);
    const handleContextMenu = useCallback((event) => {
        const { clientX, clientY, pageX, pageY } = event;
        event.preventDefault();
        setPositionState({
            clientX,
            clientY,
            pageX,
            pageY,
        });
    }, []);
    const boundingClientRect = useMemo(() => {
        return {
            top: positionState?.clientY || 0,
            left: positionState?.clientX || 0,
            x: positionState?.pageX || 0,
            y: positionState?.pageY || 0,
            bottom: 0,
            right: 0,
            height: 0,
            width: 0,
            toJSON: () => '',
        };
    }, [positionState]);
    const virtualElement = useMemo(() => {
        return {
            getBoundingClientRect: () => boundingClientRect,
        };
    }, [boundingClientRect]);
    const [popperElement, setPopperElement] = useState(null);
    const { styles, attributes, state } = usePopper(virtualElement, popperElement, {
        placement,
    });
    return {
        setPopperElement,
        styles,
        attributes,
        popperState: state,
        isPopperElementOpen: positionState !== null,
        handleContextMenu,
        closePopperElement: () => {
            setPositionState(null);
        },
    };
}
//# sourceMappingURL=useContextMenuPlacement.js.map